/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Leveling_Perm_Stream_HintInputs */



/**
* | output |
* | --- |
* | "Allows members to share their video, Screen Share or stream a game in this server." |
*
* @param {Leveling_Perm_Stream_HintInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const leveling_perm_stream_hint = /** @type {((inputs?: Leveling_Perm_Stream_HintInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Leveling_Perm_Stream_HintInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Позволяет участникам включать камеру, демонстрировать экран и стримить игры на этом сервере.")
	return /** @type {LocalizedString} */ ("Allows members to share their video, Screen Share or stream a game in this server.")
});